import React from "react";
import LandingAccordionComponent from "../LandingAccordionComponent/LandingAccordionComponent";
import localeText from "../../../../locale";
import "../../landing.css";

const LandingFaqComponent = () => {
  const questions = [
    { title: localeText("lp2Faq1Q"), content: localeText("lp2Faq1A"), id: 0 },
    { title: localeText("lp2Faq2Q"), content: localeText("lp2Faq2A"), id: 1 },
    { title: localeText("lp2Faq3Q"), content: localeText("lp2Faq3A"), id: 2 },
    { title: localeText("lp2Faq4Q"), content: localeText("lp2Faq4A"), id: 3 },
    { title: localeText("lp2Faq5Q"), content: localeText("lp2Faq5A"), id: 4 },
  ];

  return (
    <section
      className=" full-width"
      style={{ backgroundColor: "var(--extra-faq)", padding: "120px 0" }}
    >
      <div className="grid">
        <div className="col-12 md:col-5 flex flex-column gap-7">
          <div className="flex flex-column gap-2">
            <div className="eyebrow-text">{localeText("clarify")}</div>
            <div className="font-bold text-5xl title" style={{ color: "var(--extra-green)" }}>
              {localeText("frequentlyAskedQuestion")}
            </div>
            <div className="text-md" style={{ color: "var(--extra-body)" }}>
              {localeText("frequentlyAskedQuestionDescription")}
            </div>
          </div>

          <div className="flex flex-column gap-5">
            <div className="flex gap-3 align-items-start">
              <i
                className="pi pi-comment mt-1"
                style={{ color: "var(--extra-green)", fontSize: "1.3rem" }}
              ></i>
              <div className="flex flex-column gap-1">
                <div className="font-semibold" style={{ color: "var(--extra-ink)" }}>
                  {localeText("joinUs")}
                </div>
                <div className="text-sm" style={{ color: "var(--extra-body)" }}>
                  {localeText("joinUsDescription")}
                </div>
              </div>
            </div>
            <div className="flex gap-3 align-items-start">
              <i
                className="pi pi-headphones mt-1"
                style={{ color: "var(--extra-green)", fontSize: "1.3rem" }}
              ></i>
              <div className="flex flex-column gap-1">
                <div className="font-semibold" style={{ color: "var(--extra-ink)" }}>
                  {localeText("talkWithUs")}
                </div>
                <div className="text-sm" style={{ color: "var(--extra-body)" }}>
                  {localeText("talkWithUsDescription")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 md:col mt-6 md:mt-0">
          <LandingAccordionComponent questions={questions} />
        </div>
      </div>
    </section>
  );
};

export default LandingFaqComponent;
